import {
  Control,
  FieldErrors,
  useForm,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import RecursiveInnerDetailSurveyForm from "./RecursiveInnerDetailSurveyForm";
import { SurveySection } from "./types";

interface ChildProps {
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors<any>;
  watch: UseFormWatch<any>;
  recursiveSurveySections: SurveySection;
  IsSubSection: boolean | false;
  showSubmitButton: any;
  setValue: UseFormSetValue<any>;
  currentRecord: number;
  questionCounter: number;
  isDraft: boolean;
  submitButtonClicked: number;
 
}
const RecursiveDetailSurveyForm: React.FC<ChildProps> = ({
  register,
  control,
  errors,
  watch,
  recursiveSurveySections,
  IsSubSection,
  showSubmitButton,
  setValue,
  currentRecord,
  questionCounter,
  isDraft,
  submitButtonClicked,
}) => {
  const methods = useForm();

  return (
    <>
      {recursiveSurveySections &&
        (recursiveSurveySections?.DetailedInfo ||
          recursiveSurveySections?.SurveySubSection) && (
          <>
            <div
              key={recursiveSurveySections?.SurveySectionId}
              className="mb-4"
            >
              <h4 className="mx-3 sectionBorder">
                {recursiveSurveySections?.SectionTitle}
              </h4>
              {recursiveSurveySections?.DetailedInfo && (
                <RecursiveInnerDetailSurveyForm
                  register={register}
                  control={control}
                  errors={errors}
                  watch={watch}
                  IsinnerSubSection={false}
                  RecursiveInnerSurveySections={
                    recursiveSurveySections?.DetailedInfo
                  }
                  showSubmitButton={showSubmitButton}
                  setValue={setValue}
                  questionCounter={questionCounter++}
                  isDraft={isDraft}
                  submitButtonClicked={submitButtonClicked}
                 
                />
              )}
              {recursiveSurveySections?.SurveySubSection &&
                recursiveSurveySections?.SurveySubSection?.map(
                  (subsection: any, index) => (
                    <RecursiveDetailSurveyForm
                      register={register}
                      control={control}
                      errors={errors}
                      watch={watch}
                      recursiveSurveySections={subsection}
                      IsSubSection={true}
                      showSubmitButton={showSubmitButton}
                      setValue={setValue}
                      currentRecord={index}
                      questionCounter={questionCounter++}
                      isDraft={isDraft}
                      submitButtonClicked={submitButtonClicked}
                   
                    />
                  )
                )}
            </div>
          </>
        )}
    </>
  );
};
export default RecursiveDetailSurveyForm;
